import Vue from 'vue'
import VueRouter from 'vue-router'
import LivingImages from '../views/LivingImages.vue'
import FilmPosters from '../views/FilmPosters.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'home',
      component: LivingImages
    },
    {
      path: '/posters',
      name: 'posters',
      component: FilmPosters
    }
  ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
